import { render, staticRenderFns } from "./redenvelopeHome.vue?vue&type=template&id=7808e98e&scoped=true"
import script from "./redenvelopeHome.vue?vue&type=script&lang=js"
export * from "./redenvelopeHome.vue?vue&type=script&lang=js"
import style0 from "./redenvelopeHome.vue?vue&type=style&index=0&id=7808e98e&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7808e98e",
  null
  
)

export default component.exports